import { useCallback, useState } from 'react';
import { Button, Row, Col, ListGroupItem } from 'reactstrap';
import moment from 'moment';
import PluginClientManifestConfigurationModal from '../ClientManifest/PluginClientManifestConfigurationModal';
import PluginClientAddingConfirmationModal from '../ClientManifest/PluginClientAddingConfirmationModal';

const ClientPluginListItem = ({
    pluginId,
    pluginName,
    defaultVersion,
    refreshManifest,
}) => {
    const [addingConfig, setaddingConfig] = useState(false);
    const [addingConfirmation, setaddingConfirmation] = useState(false);
    const [pluginConfiguration, setPluginConfiguration] = useState(null);
    const [pluginNotes, setPluginNotes] = useState('');

    const toggleAddingConfiguration = useCallback(
        () => setaddingConfig(!addingConfig),
        [addingConfig]
    );

    const toggleAddingConfirmation = useCallback(
        () => setaddingConfirmation(!addingConfirmation),
        [addingConfirmation]
    );

    const handleNoteChange = (event) => {
        setPluginNotes(event.target.value);
    };

    return (
        <>
            <PluginClientAddingConfirmationModal
                isOpen={addingConfirmation}
                pluginId={pluginId}
                pluginName={pluginName}
                pluginConfiguration={pluginConfiguration}
                notes={pluginNotes}
                refreshManifest={() => refreshManifest()}
                resetConfig={() => setPluginConfiguration(null)}
                toggle={toggleAddingConfirmation}
            />
            <PluginClientManifestConfigurationModal
                isOpen={addingConfig}
                pluginId={pluginId}
                defaultVersion={defaultVersion}
                toggle={toggleAddingConfiguration}
                addConfigurationBehavior={setPluginConfiguration}
            />
            <ListGroupItem className="text-dark">
                <Row className="my-2">
                    <Col xs="12" md="6" lg="5">
                        <div>
                            <div>{pluginName}</div>
                            <div className="text-14 op-7">
                                Plugin Id: {pluginId}
                            </div>
                            {pluginConfiguration !== null && (
                                <div key={pluginConfiguration.pluginId}>
                                    <div className="text-14 op-7">
                                        Plugin Version:{' '}
                                        {pluginConfiguration?.pluginVersion +
                                            `\xa0 Release Date: ${moment
                                                .utc(
                                                    pluginConfiguration
                                                        ?.pluginVersion
                                                        ?.releaseDate
                                                )
                                                .local()
                                                .format('M/D/YYYY LT')}`}
                                    </div>
                                    <div className="text-14 op-7">
                                        Target State:{' '}
                                        {pluginConfiguration?.targetState
                                            .isCached
                                            ? 'cached'
                                            : 'not cached'}
                                        ,{' '}
                                        {pluginConfiguration?.targetState
                                            .isInstalled
                                            ? 'installed'
                                            : 'not installed'}
                                        ,{' '}
                                        {pluginConfiguration?.targetState
                                            .isRunning
                                            ? 'running'
                                            : 'not running'}
                                    </div>
                                </div>
                            )}
                        </div>
                    </Col>
                    <Col xs="12" md="3" lg="4">
                        <div>
                            <div>Note:</div>
                            <textarea
                                name="note"
                                value={pluginNotes}
                                className="w-100 p-2 rounded border"
                                onChange={handleNoteChange}
                            />
                        </div>
                    </Col>
                    <Col xs="12" md="3" lg="3">
                        <div>
                            <Button
                                className="mr-1"
                                color={'primary'}
                                size="sm"
                                onClick={toggleAddingConfiguration}>
                                Set Configuration
                            </Button>
                            <Button
                                className="mr-1"
                                color={'success'}
                                size="sm"
                                disabled={pluginConfiguration === null}
                                onClick={toggleAddingConfirmation}>
                                Add
                            </Button>
                            <Button
                                className="mr-1"
                                color={'secondary'}
                                size="sm"
                                disabled={
                                    pluginConfiguration === null &&
                                    pluginNotes === ''
                                }
                                onClick={() => {
                                    setPluginConfiguration(null);
                                    setPluginNotes('');
                                }}>
                                Reset
                            </Button>
                        </div>
                    </Col>
                </Row>
            </ListGroupItem>
        </>
    );
};

export default ClientPluginListItem;
